package components.company.pricelist.tables

import components.company.pricelist.dataSheetLink
import components.company.pricelist.priceListExportHeading
import it.neckar.lizergy.model.price.PriceListExportCategory
import it.neckar.open.collections.fastForEachIndexed
import it.neckar.open.kotlin.lang.ifNull
import it.neckar.open.time.formatHourAndMinutes
import kotlinx.css.*
import kotlinx.html.ThScope
import plannerI18nConfiguration
import react.*
import react.dom.*
import store.hooks.useSelectPriceList
import style.toStyleClass
import styled.*

val BatteryPriceTable: FC<Props> = fc("BatteryPriceTable") {
  val priceList = useSelectPriceList()

  val batteryPrices = priceList.batteryStoragePrices
  val batteryInverterPrices = priceList.batteryInverterPrices
  val batteryStorageExtraPrices = priceList.batteryStorageExtraPrices


  div("col") {
    priceListExportHeading(PriceListExportCategory.BatteryStorages)

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col, "text-end") {
            +"Kapazität"
          }
          th(ThScope.col, "text-end") {
            +"Nutzbare Kapazität"
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }

          th(ThScope.col) { }
        }
      }

      tbody {
        batteryPrices.available.fastForEachIndexed { index, batteryStorageType ->
          val lifeCycleState = batteryStorageType.lifeCycleState

          tr(classes = lifeCycleState.toStyleClass()) {
            key = batteryStorageType.uuid.toString()

            th(ThScope.row) {
              +"${index + 1}"
            }
            styledTd {
              css {
                maxWidth = 250.px
              }
              +batteryStorageType.description
            }

            td("text-end") {
              +batteryStorageType.storageCapacity.format()
            }
            td("text-end") {
              +batteryStorageType.usableStorageCapacity.format()
            }

            td("text-end") {
              +batteryPrices[batteryStorageType].materialPrice.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryPrices[batteryStorageType].materialPrice.sellingPrice.format().ifNull("-")
            }

            td("text-center") {
              batteryStorageType.dataSheetPath?.let { dataSheetLink(it) }
            }
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            th(ThScope.row) {}
            styledTd {
              css {
                maxWidth = 250.px
              }
              +"Kleinteile und Zubehör"
            }

            td("text-end") {}
            td("text-center") {}

            td("text-end") {
              +batteryStorageExtraPrices[batteryStorageType].inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryStorageExtraPrices[batteryStorageType].sellingPrice.format().ifNull("-")
            }

            td("text-center") {}
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              +"Arbeitszeit:"
            }
            td("text-end") {
              +batteryPrices[batteryStorageType].workingTimes.workingTime.formatHourAndMinutes().ifNull("-")
            }
            td("text-center") {
            }

            td("text-end") {
              +batteryPrices[batteryStorageType].workingTimes.priceWithProfit.inputPrice.format().ifNull("-")
            }
            td("text-end") {
              +batteryPrices[batteryStorageType].workingTimes.priceWithProfit.sellingPrice.format().ifNull("-")
            }

            td("text-center") {}
          }

          tr(classes = lifeCycleState.toStyleClass()) {
            td {
            }
            th(ThScope.row) {
              b { +"Gesamt:" }
            }
            td("text-end") {
            }
            td("text-center") {
            }

            td("text-end") {
              b {
                val inputPrice = batteryPrices[batteryStorageType].inputPrice + batteryStorageExtraPrices[batteryStorageType].inputPrice
                +inputPrice.format().ifNull("-")
              }
            }
            td("text-end") {
              b {
                val sellingPrice = batteryPrices[batteryStorageType].sellingPrice + batteryStorageExtraPrices[batteryStorageType].sellingPrice
                +sellingPrice.format().ifNull("-")
              }
            }

            td("text-center") {}
          }

        }
      }
    }

    hr("my-5") {}

    priceListExportHeading(PriceListExportCategory.BatteryInverters)

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col) {
            +"Hersteller"
          }
          th(ThScope.col) {
            +"Entladeleistung"
          }
          th(ThScope.col) {
            +"Phase"
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }

          th(ThScope.col) { }
        }
      }

      tbody {
        batteryInverterPrices.available.fastForEachIndexed { inverterIndex, inverter ->
          tr(classes = inverter.lifeCycleState.toStyleClass()) {
            key = inverter.uuid.toString()

            th(ThScope.row) {
              +(inverterIndex + 1).toString()
            }
            td {
              +inverter.description
            }
            td {
              +inverter.manufacturer.name
            }
            td {
              +inverter.dischargeCapacity.format(plannerI18nConfiguration)
            }
            td {
              +inverter.phase.toString()
            }

            td("text-end") {
              +batteryInverterPrices[inverter].inputPrice.format()
            }
            td("text-end") {
              +batteryInverterPrices[inverter].sellingPrice.format()
            }

            td("text-center") {
              inverter.dataSheetPath?.let { dataSheetLink(it) }
            }
          }
        }
      }
    }

  }
}
